module.exports = __webpack_public_path__ + "static/media/hallo1.530fad67.jpg";